export class TaskDebouncer {
	#timer = null;
	#queue = [];
	#delay;

	constructor(delay = 50) {
		this.#delay = delay;
	}

	/**
	 * @param {Function} func - 실행할 함수
	 * @param {...any} args - 함수에 전달할 임의의 파라미터들
	 */
	exec(func, ...args) {
		// 1. 어떤 함수와 어떤 인자들이 들어왔는지 큐에 저장
		this.#queue.push({ func, args });

		// 2. 디바운스 타이머 설정
		if (this.#timer) clearTimeout(this.#timer);

		this.#timer = setTimeout(() => this.#flush(), this.#delay);
	}

	execWithKey(key, func, ...args) {
		// 1. 같은 키(예: 'resize')가 들어오면 이전 큐에서 해당 키 삭제 (중복 제거)
		this.#queue = this.#queue.filter(task => task.key !== key);

		// 2. 새로운 태스크 추가
		this.#queue.push({ key, func, args });

		if (this.#timer) clearTimeout(this.#timer);
		this.#timer = setTimeout(() => this.#flush(), this.#delay);
	}

	#flush() {
		if (this.#queue.length === 0) return;

		// 3. 현재까지 쌓인 큐를 쏙 빼옴
		const tasks = this.#queue.splice(0, this.#queue.length);
		const seen = new Set();

		tasks.forEach(task => {
			// 4. 핵심: 함수 이름과 인자들을 문자열로 합쳐서 유니크 키 생성
			// JSON.stringify를 통해 [1, {a:1}] 같은 파라미터도 문자열로 비교 가능
			const identifier = `${task.func.name}_${JSON.stringify(task.args)}`;

			if (!seen.has(identifier)) {
				// 5. 중복이 아닐 때만 원래 인자들(...args) 그대로 실행
				task.func(...task.args);
				seen.add(identifier);
			}
		});

		this.#timer = null;
	}
}